$('.acc-trigger').on('click', function () {
  $(this).prev().stop().slideToggle();
  if ($(this).hasClass('is-active')) {
    $(this).removeClass('is-active').text('さらに詳しく読む');
  } else {
    $(this).addClass('is-active').text('内容を閉じる');
  }
});
